<template>

<!-- <v-scale-screen width="500" height="1080"> -->
  <div v-if="hasToken" class="home-map" v-resize="onResize">
    <v-header v-resize="onResize"></v-header>
    <el-row style="height:calc(100% - .3585rem)">
      <el-col :span="5" style="display:inline-block;height:100%">
        <div class="page-panel" style="margin-top:.0521rem;height: 2rem;" v-resize="onResize">
          <div class="image-border image-border1"></div>
          <div class="image-border image-border2"></div>
          <div class="image-border image-border3"></div>
          <div class="image-border image-border4"></div>
          <div class="chart-wrapper" style="height:0.9858rem">
            <v-pie-chart ref="echarts" :chart-data="total" :chart-title="'一步位来平台'" :height="'100%'"></v-pie-chart>
          </div>
          
          <el-form label-width="" class="data-form"  style="margin-left: 12%;">
            <el-form-item label="总占位费" style = "margin-left: 0%;">
              <span>{{totalData.occHisIncome == null ? 0:totalData.occHisIncome}}</span>
              <span class="unit-label">元</span>
            </el-form-item>
            <el-form-item label="总使用量" style = "margin-left: 0%;">
              <span>{{totalData.useHisNum == null ? 0:totalData.useHisNum}}</span>
              <span class="unit-label">次</span>
            </el-form-item>
            <el-form-item label="当日占位费" style = "margin-left: 0%;">
              <span>{{totalData.occIncome == null ? 0:totalData.occIncome}}</span>
              <span class="unit-label">元</span>
            </el-form-item>
            <el-form-item label="当日使用量" style = "margin-left: 0%;">
              <span>{{totalData.useNum == null ? 0:totalData.useNum}}</span>
              <span class="unit-label">次</span>
            </el-form-item>



          </el-form>
        </div>
        <div class="page-panel" style="height:calc(100% - 3.65rem)">
          <div class="image-border image-border1"></div>
          <div class="image-border image-border2"></div>
          <div class="image-border image-border3"></div>
          <div class="image-border image-border4"></div>

          <div class="chart-wrapper" style="height:1.35rem">
            <v-line-bar-chart  :chart-data="totalStatistics" :chart-title="'（月）统计'" :height="'1.3rem'" @xAxisClicked="handleTotalXClicked"></v-line-bar-chart>
          </div>
          <div class="chart-wrapper" style="height:1rem;">
            <v-line-bar-chart  :chart-data="totalDayStatistics" :chart-title="`${totalChartMonth}（日）统计`" :height="'1.3rem'" :mode="'day'"></v-line-bar-chart>
          </div>
        </div>
      </el-col>
      <el-col :span="14" style="height:3rem">
        <div class="chart-wrapper" style="height:3.2rem;padding-top:.0313rem;">
          <v-map-chart :chart-data="chartData" :height="'3.5rem'" @parkChange='handleParkChange'></v-map-chart>
        </div>
        <el-row style="height:calc(65% - .1042rem);" class="page-panel">
          <div class="image-border image-border1"></div>
          <div class="image-border image-border2"></div>
          <div class="image-border image-border3"></div>
          <div class="image-border image-border4"></div>
          <el-col :span="12" style="height:1.4rem">
            <div class="chart-wrapper" style="height:1.4rem">
              <v-line-bar-chart v-if="currentVisible&&!singleLoading" :chart-data="singleStatistics" :location="currentPark.parkfieldName" :chart-title="'（月）统计'" :height="'100%'" @xAxisClicked="handleSingleXClicked"></v-line-bar-chart>
            </div>
          </el-col>
          <el-col :span="12" style="height:1.4rem">
            <div class="chart-wrapper" style="height:1.4rem">
              <v-line-bar-chart v-if="currentVisible&&!singleLoading" :chart-data="singleDayStatistics" :location="currentPark.parkfieldName" :chart-title="` ${singleChartMonth}（日）统计`" :height="'100%'" :mode="'day'"></v-line-bar-chart>
            </div>
          </el-col>
          
        </el-row>
      </el-col>
      <el-col :span="5" style="display:inline-block;height:100%">
        <div class="page-panel" style="margin-top:.0521rem;">
          <div class="image-border image-border1"></div>
          <div class="image-border image-border2"></div>
          <div class="image-border image-border3"></div>
          <div class="image-border image-border4"></div>
          <div class="chart-wrapper" style="height:1.05rem">
            <v-pie-chart v-if="currentVisible" :chart-data="single"  :chart-title="`${currentPark.parkfieldName}`" :height="'80%'"></v-pie-chart>
          </div>
          <el-form label-width="" class="data-form" style="margin-left: 4%;">
            <el-form-item label="总占位费" style = "margin-left: 0%;">
              <span>{{currentSingleData.occHisIncome1park == null ? 0:currentSingleData.occHisIncome1park}}</span>
              <span class="unit-label">元</span>
            </el-form-item>
            <el-form-item label="总使用量" style = "margin-left: 0%;">
              <span>{{currentSingleData.useHisNum1park == null ? 0:currentSingleData.useHisNum1park}}</span>
              <span class="unit-label">次</span>
            </el-form-item>
            <el-form-item label="当日占位费" style = "margin-left: 0%;">
              <span>{{currentSingleData.occIncome1park == null ? 0:currentSingleData.occIncome1park}}</span>
              <span class="unit-label">元</span>
            </el-form-item>
            <el-form-item label="当日使用量" style = "margin-left: 0%;">
              <span>{{currentSingleData.useNum1park == null ? 0:currentSingleData.useNum1park}}</span>
              <span class="unit-label">次</span>
            </el-form-item>
          </el-form>
        </div>
        <div class="status-panel page-panel"  style="height:calc(100% - 4.95rem);text-align:center;padding-top:10px;overflow: hidden;">
          

<span style="color: rgb(255, 255, 255);text-align: center;text-shadow: 3px 3px 3px #849ddb;font-size: 13px;">车辆进出实时动态</span>
          <ul style="list-style-type: none;text-align:left;padding-left: 14px;font-size: 15px;">
            <li v-for="item in list" :key="item" style="position:relative" >
              <span style="color:#3888fa;font-size: .08rem;">{{ item[2] }}</span><br>
              <span style="color: #fff;font-size: .08rem;">{{ item[0] }}</span>
              
              <span style="color:#ffffff;margin-left:40px;font-size: .08rem;">{{ item[3] }}</span>
              <el-tag
                v-if="item[1] == '进'"
                size="medium"
                style="margin-left:40px;position:absolute;right:0;top:0.01rem"
                type="success"
                effect="dark"
                >进</el-tag
              >
              <el-tag
                v-else-if="item[1] == '出'"
                size="medium"
                type="danger"
                style="margin-left:40px;position:absolute;right:0;top:0.01rem"
                effect="dark"
                >出</el-tag
              >
             
              </li>
          </ul>

        </div>
            
        <div v-loading="!voiceLoaded" class="media-container" id="ui-talk">
            <div id="video-container" style="width:100%;height:100%"></div>
          </div>
      </el-col>
    </el-row>
  </div>
<!-- </v-scale-screen> -->
</template>

<script>
/* global EZUIKit */
import axios from 'axios'
// import VueWebsocket from 'vue-websocket'

import io from 'socket.io-client';
import resize from 'vue-resize-directive'
import { getToken } from '../../utils/auth'
import { getparkList } from '../../api/parkInfo'
import vHeader from './Header.vue'
import vPieChart from './PieChart'
import vLineChart from './LineChart'
import vMapChart from './mapChart'
import vLineBarChart from './LineBarChart'
import { getStatisticsInfo, getMonthRecord, getDayRecord,lcebchargerlog,lcebchargerlogStatis,getebMonthRecord,getebDayRecord } from '../../api/lcChargerLog'
import Cookies from 'js-cookie'
import { connectWebsocket, closeWebsocket, sendMsg } from "../../utils/websocket";

export default {
  directives: {
      resize,
  },
  name: 'home',
  data () {
    return {
      socket:null,
      hasToken: false,
      ebparkfieldId:'',
      totalNum: {
        icomeLoading:'',
        usedCharger:'',
        freeCharger:'',
        bookedCharger:'',
        repairCharger:'',
        useNum:'',
        occIncome:'',
        useHisNum:'',
        occHisIncome:''
      },
      totalSevenDaysNum: [],
      singleNum: {
        occIncome1park:'',
        useNum1park:'',
        occHisIncome1park:'',
        useHisNum1park:'',
        usedCharger:'',
        freeCharger:'',
        bookedCharger:'',
        repairCharger:''
      },
      singleSevenDaysNum: [],
      totalLoading: false,
      singleLoading: false,
      totalStatistics: {},
      totalDayStatistics: {},
      totalChartMonth: '',
      singleStatistics: {},
      singleDayStatistics: {},
      singleStatistics2: {},
      singleStatistics3: {},
      singleDayStatistics2: {},
      singleDayStatistics3: {},
      singleChartMonth: '',
      currentPark: {},
      currentVisible: false,
      mapData: [],
      chartData: [],
      playerInstance: null,
      ezuikitTalkData: {},
      voiceLoaded: false,
      voiceWidth: '',
      voiceHeight: '',
      parkfieldId: '',
      roleId:'',
      ip:'192.168.3.3',
      lockReconnect:false,
      message: "",
      randomId:null,
      value:'',
      list:[]

    }
  },
  components: { vHeader, vPieChart, vLineChart, vMapChart, vLineBarChart }, // , vVoice
  mounted: function () {

    
    this.ROLECODE = Cookies.get('ROLECODE')
    this.roleId = Cookies.get('ROLEID')
    this.$nextTick(() => {
      this.$refs.echarts.resize();
    });
    this.$nextTick(function () {
      if (!getToken()) {
        this.hasToken = false
        this.$commons.toLogin()
      } else {
        this.hasToken = true
        this.getParkInfo()
        this.$nextTick(function () {
        })
      }
    })

    this.initWebSocket();

  },
  created () {
    this.startUpdate3min()
    this.startUpdateTomorrow()

  },
  computed: {
    total: function () {
      var data = []
      data.push({ value: this.totalNum['usedCharger'], name: '使用' })
      data.push({ value: this.totalNum['freeCharger'], name: '空闲' })       
      data.push({ value: this.totalNum['bookedCharger'], name: '预约' })    
      data.push({ value: this.totalNum['repairCharger'], name: '离线' })
 
      return data
    },
    totalData: function () {
      var data = {}
      data.useNum = this.totalNum['useNum']
      data.occIncome = this.totalNum['occIncome']
      data.useHisNum = this.totalNum['useHisNum']
      data.occHisIncome = this.totalNum['occHisIncome']
      return data
    },
 
    single: function () {
      var data = []
      data.push({ value: this.singleNum['usedCharger'], name: '使用' })
      data.push({ value: this.singleNum['freeCharger'], name: '空闲' })
      if( this.singleNum['bookedCharger'] > 0){
          data.push({ value: this.singleNum['bookedCharger'], name: '预约' })
      }
     if( this.singleNum['repairCharger'] > 0){
          data.push({ value: this.singleNum['repairCharger'], name: '离线' })
     }
      
      return data

    },
    currentSingleData: function () {
      var data = {}
      data.occIncome1park = this.singleNum['occIncome1park']
      data.useNum1park = this.singleNum['useNum1park']
      data.occHisIncome1park = this.singleNum['occHisIncome1park']
      data.useHisNum1park = this.singleNum['useHisNum1park']
      return data
    }
  },

  destroyed () {
    closeWebsocket() //断开连接
  },
  methods: {


    initWebSocket () {
      connectWebsocket("ws://pc2200.pacargle.com:9900/webSocket/"+this.ROLECODE, {}, (res) => {
        console.log("onWsMessage接收到服务器的数据: ", res)
        var parkData = res.split(";")
        if(parkData.length > 1){
          console.log("33333333333333333333",parkData)
          if(parkData[4] == this.ROLECODE || this.ROLECODE == '0000'){
             console.log("4444",parkData)
             if(parkData[1] == 2){
                parkData[1] = "出"
             }else if(parkData[1] == 1){
                parkData[1] = "进"
             }     
             if(parkData[0].length > 10){
               parkData[0] = "扫码抬杆"
             }else{
             }
            //  parkData[3] = parkData[3].substr(-8,8) 

             if(this.list.length > 4){
              this.list.splice(0,1)
             }

             this.list.push(parkData)
             console.log("66666",this.list)
          }
        }
        



      },
      (err) => {
        console.log("断开重连");
      })
    },
 
//发送消息
    // sendMsg () {
    //   sendMsg(this.value);  //value是发送的值
    //   this.value = "";
    // },

        //           initWebSocket() {
        //             console.log('initWesocket==')

        //             // 建立WebSocket连接
        //             this.socket = new VueWebsocket("ws://localhost:9900/webSocket/"+this.ROLECODE);  
        //             console.log('initWesocket==00')
        //             // 监听WebSocket的open事件，当连接打开时触发  
        //             this.socket.onopen = (event) => {  
        //                 console.log('socket.onopen=='); 

        //                 //可删除，只是用来测试后端自动断开连接的时间
        //                 // setInterval(() => {  
        //                 //     this.second++;  
        //                 // }, 1000);
        //             };  
                            
        //             // 监听WebSocket的message事件，当收到服务器消息时触发  
        //             this.socket.onmessage = (event) => {  
        //                 console.log('socket.onmessage==', event.data);
        //                 var data=JSON.parse(event.data)
        //                 switch(data.type){ //根据WebSocket返回值的某个字段，区分改做什么事情
        //                     case 'connect': // // {"type":"connect","data":"7f0000010b540000000a"}
        //                         //写你自己的逻辑                               
        //                         break;
        //                     case 'xxx': 
        //                         //写你自己的逻辑
        //                         break;
        //                 }						
        //             };  
                            
        //             // 监听WebSocket的close事件，当连接关闭时触发  
        //             this.socket.onclose = (event) => {  
        //                 console.log('socket.onclose==');
        //                 console.log(`WebSocket连接${this.second}秒后关闭了`);

        //                 //连接关闭，就重新连接
        //                 this.reconnect()
        //             };  
                            
        //             // 监听WebSocket的error事件，当发生错误时触发  
        //             this.socket.onerror = (error) => {  
        //                 console.error('socket.onerror:', error);  
        //                 this.reconnect()
        //             }; 
        //         },
        
        //  reconnect() {//断线重新连接
        //             console.log('断线重新连接==');
        //             var that = this;
        //             if(that.lockReconnect) {
        //                 return;
        //             };
        //             that.lockReconnect = true;
        //             //没连接上会一直重连，设置延迟避免请求过多
        //             setTimeout(function () {
        //                 //重新连接
        //                 that.initWebSocket();
        //                 that.lockReconnect = false;
        //             },10000);
        //           },

    converData (data) {
      var res = []
      for (var i = 0; i < data.length; i++) {
        res.push({
          name:data[i].parkfieldName,
          value: [data[i].longitude, data[i].latitude, data[i].parkfieldId,data[i].freeCharger]
        })
      }
      console.log("000005555555555555555555555555555555",res)
      return res
    },
    
    handleParkChange (index, id) {

      this.getStatisticsInfo(id)

      if (id) {

          if (this.parkfieldId != id) {
          this.currentVisible = false
          this.$nextTick(()=>{

            this.matchingParkFieldInfo(id)

            this.getHalfYearData(id)
          })
          document.getElementById('video-container').remove()
          var containerDiv = document.createElement('div')
          containerDiv.id = 'video-container'
          containerDiv.style.width = '100%'
          containerDiv.style.height = '100%'
          document.getElementById('ui-talk').appendChild(containerDiv)
          this.play(id)
         }
        console.log(this.currentPark.parkfieldName)
      }
     
    },

    initTalkPlayer (id) {
      var url
      url = this.currentPark.url
      this.voiceWidth = document.getElementById('ui-talk').clientWidth
      this.voiceHeight = document.getElementById('ui-talk').clientHeight
      this.playerInstance = new EZUIKit.EZUIKitPlayer({
        autoplay: true,
        id: 'video-container',
        accessToken: this.currentPark.accessToken,
        url: url,
        template: 'voice', // simple - 极简版;standard-标准版;security - 安防版(预览回放);voice-语音版；
        width: this.voiceWidth,
        height: this.voiceWidth * 9 / 16
      })

      this.voiceLoaded = true
      
    },

    play (id) {
      var params = new FormData()
      params.append('accessToken', this.currentPark.accessToken)
      params.append('source', this.currentPark.source)
      axios.post('https://open.ys7.com/api/lapp/live/video/open', params, {
        timeout: 5000
      })
        .then(res => {
          if (res.data.code === '10002') {
            this.getAccessToken((id) => {
              this.play(id)
            })
          } else {
            this.getAddress(id)
            setTimeout(() => {
              this.initTalkPlayer(id)
            }, 2500)
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    getAccessToken (id, callback) {
      callback = callback || function () {}

       localStorage.setItem('accessToken', this.currentPark.accessToken)
 
    },
 
    getAddress (id) {
      var params = new FormData()
      params.append('accessToken', this.currentPark.accessToken)
      params.append('source', this.currentPark.source)
      axios.post('https://open.ys7.com/api/lapp/live/address/get', params, {
        timeout: 5000
      })
        .then(res => {
          console.log(res)
        })
        .catch(e => {
          console.log(e)
        })
    },

    closeChannel (callback) {
      callback = callback || function () { }
      var params = new FormData()
      params.append('accessToken', this.currentPark.accessToken)
      params.append('source', this.currentPark.source)
      return axios.post('https://open.ys7.com/api/lapp/live/video/close', params, {
        timeout: 5000
      })
        .then(res => {
          // console.log(res)
          callback()
        })
        .catch(e => {
          console.log(e)
        })
    },

    handleRestart () {
      this.closeChannel(() => {
        this.$refs.voiceVideo.init()
      })
    },

    matchingParkFieldInfo (id) {
   
      for (var i = 0; i < this.mapData.length; i++) {
        
        if (this.mapData[i].parkfieldId === id) {

          //this.minitorInfo = this.mapData[i]
          this.currentPark = this.mapData[i]
          this.parkfieldId = this.mapData[i].parkfieldId
          this.currentVisible = true

        }
        
      }
 
    },
    getParkInfo () {
     
      getparkList().then(resp => {
        if (resp.errmsg === 'ok') {
  
          this.mapData = resp.data// 总数
          this.chartData = this.converData(this.mapData)
          this.getHalfYearData(null)
          this.matchingParkFieldInfo(this.mapData[0].parkfieldId)

          this.getStatisticsInfo(this.parkfieldId)// 单个停车场数据
          this.getHalfYearData(this.parkfieldId)
          this.getAccessToken(this.parkfieldId)
          this.play(this.parkfieldId)

          this.currentVisible = true
          // this.icomeLoading = this.mapData[0].managerId
        }
      }).catch(e => {
        console.log(e)
      })
    },
    
    getStatisticsInfo (parkfieldId, callback) { // 历史实时数据，当天实时数据，车位实时状态3部分数据
      var _this = this
      callback = callback || function () { }
      getStatisticsInfo(parkfieldId).then(resp => {
        if (resp.errmsg === 'ok') {
        
          _this.totalNum.bookedCharger = resp.data.bookedCharger
          _this.totalNum.freeCharger = resp.data.freeCharger
          _this.totalNum.repairCharger = resp.data.repairCharger
          _this.totalNum.usedCharger = resp.data.usedCharger

          _this.totalNum.useNum = resp.data.useNum
          _this.totalNum.occIncome = resp.data.occIncome
          _this.totalNum.useHisNum = resp.data.useHisNum
          _this.totalNum.occHisIncome = resp.data.occHisIncome

          _this.singleNum.occIncome1park = resp.data.occIncome1park
          _this.singleNum.useNum1park = resp.data.useNum1park
          _this.singleNum.occHisIncome1park = resp.data.occHisIncome1park
          _this.singleNum.useHisNum1park = resp.data.useHisNum1park

          _this.singleNum.usedCharger = resp.data.usedCharger1park
          _this.singleNum.freeCharger = resp.data.freeCharger1park
          _this.singleNum.bookedCharger = resp.data.bookedCharger1park
          _this.singleNum.repairCharger = resp.data.repairCharger1park

          callback()
        }
      })

    },



    startUpdate3min () { // 每3分钟刷新
      window.setInterval(() => {
        this.getStatisticsInfo(this.parkfieldId)

      }, 3 * 60000)
    },
    startUpdateTomorrow () { // 次日零点刷新
      var date = new Date()
      var timeStamp = new Date(new Date().setHours(0, 0, 0, 0) + 86400 * 1000)
      var timer = timeStamp - date
      window.setInterval(() => {
        this.getHalfYearData(null)
        this.getHalfYearData(this.parkfieldId)
      }, timer)
    },
    getHalfYearData (parkfieldId) {
      getMonthRecord(parkfieldId).then(resp => {
        if (resp.errmsg === 'ok') {
          var halfYearData = resp.data.statistics
          var lastMonth = ''
          console.log(halfYearData)
          if (parkfieldId == null || parkfieldId === '') {
            this.totalStatistics = {
              xAxis: [],
              series: [
                {
                  title: '使用量',
                  statistics: []
                },
                {
                  title: '占位费',
                  statistics: []
                }
              ]
            }
            for (var i = 0; i < halfYearData.length; i++) {
              this.totalStatistics.xAxis.push(halfYearData[i].month)
              this.totalStatistics.series[0].statistics.push(halfYearData[i].useAmount)
              this.totalStatistics.series[1].statistics.push(halfYearData[i].occIncome)
              lastMonth = halfYearData[i].month
            }
            this.getOneMonthData(null, lastMonth)
          } else {
            this.singleStatistics = {
              xAxis: [],
              series: [
                {
                  title: '使用量',
                  statistics: []
                },
                {
                  title: '占位费',
                  statistics: []
                }
              ]
            }
            for (i = 0; i < halfYearData.length; i++) {
              this.singleStatistics.xAxis.push(halfYearData[i].month)
              this.singleStatistics.series[0].statistics.push(halfYearData[i].useAmount)
              this.singleStatistics.series[1].statistics.push(halfYearData[i].occIncome)
              lastMonth = halfYearData[i].month
            }
            this.getOneMonthData(parkfieldId, lastMonth)
          }
        }
      })
    },
    getOneMonthData (parkfieldId, month) {
      getDayRecord(parkfieldId, month).then(resp => {
        if (resp.errmsg === 'ok') {
          var oneMonthData = resp.data.statistics
          if (parkfieldId == null || parkfieldId === '') {
            this.totalChartMonth = month
            this.totalDayStatistics = {
              xAxis: [],
              series: [
                {
                  title: '使用量',
                  statistics: []
                },
                {
                  title: '占位费',
                  statistics: []
                }
              ]
            }
            for (var i = 0; i < oneMonthData.length; i++) {
              this.totalDayStatistics.xAxis.push(oneMonthData[i].day)
              this.totalDayStatistics.series[0].statistics.push(oneMonthData[i].useAmount)
              this.totalDayStatistics.series[1].statistics.push(oneMonthData[i].occIncome)
            }
          } else {
            this.singleChartMonth = month
            this.singleDayStatistics = {
              xAxis: [],
              series: [
                {
                  title: '使用量',
                  statistics: []
                },
                {
                  title: '占位费',
                  statistics: []
                }
              ]
            }
            for (i = 0; i < oneMonthData.length; i++) {
              this.singleDayStatistics.xAxis.push(oneMonthData[i].day)
              this.singleDayStatistics.series[0].statistics.push(oneMonthData[i].useAmount)
              this.singleDayStatistics.series[1].statistics.push(oneMonthData[i].occIncome)
            }
          }
        }
      })
    },
    handleTotalXClicked (value) {
      this.getOneMonthData(null, value)
    },
    handleSingleXClicked (value) {
      this.getOneMonthData(this.parkfieldId, value)
    }
  },
  deactivated () {
    this.closeChannel()
  },
  beforeDestroy () {
    this.closeChannel()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
$bg: #283443;
$light_gray: #fff;
$cursor: #fff;
ul li{
  margin-bottom:2px;
  border-bottom: 1px solid #788095;
    padding-bottom: 5px;
}
.home-map {
  background-color:#000726;
  width: 100%;
  height:7rem;
  overflow: hidden;
  color: $light_gray;
  .chart-wrapper {
    background: transparent;
    padding: .0833rem .0833rem 0;
  }
  .el-form-item {
    margin-bottom: .026rem;
  }
  .el-form-item__label {
    font-size:.08rem;
    color:#ffffff;
    font-weight: 200;
    line-height: .1573rem;
  }
  .el-form-item__content {
    text-align: center;
    font-size: .1263rem;
    color: #20fdfa;
    font-family: cursive;
    line-height: 0.1542rem;
  }
  .unit-label {
    margin-right: .2604rem;
    float: right;
    font-size: .0938rem;
    font-family: 'iconfont';
    font-size: .0833rem;
  }
  .status-panel {
    height: calc(100% - 2.4635rem);
    .status-label {
      color: #ccc;
      font-size: .125rem;
      font-weight: bold;
      width: 50%;
      margin: .1042rem;
    }
    i {
      font-size: .2604rem;
      width: 50%;
      color: #67c23a;
    }
    .fault {
      color: #f56c6c;
    }
  }
  .page-panel {
    border: 1px dashed rgba(64, 158, 255, 0.3);
    margin: .0521rem;
    position: relative;
    width: calc(100% -0.1042rem);
    background-color: rgba(64, 158, 255, 0.1);
    .image-border {
      position: absolute;
      width: .1042rem;
      height: .1042rem;
    }

    .image-border1 {
      top: 0;
      left: 0;
      border-left: 3px solid rgba(64, 158, 255, 0.7);
      border-top: 3px solid rgba(64, 158, 255, 0.7);
    }

    .image-border2 {
      top: 0;
      right: -2px;
      border-right: 3px solid rgba(64, 158, 255, 0.7);
      border-top: 3px solid rgba(64, 158, 255, 0.7);
    }

    .image-border3 {
      bottom: 0;
      left: 0;
      border-bottom: 3px solid rgba(64, 158, 255, 0.7);
      border-left: 3px solid rgba(64, 158, 255, 0.7);
    }

    .image-border4 {
      bottom: 0;
      right: -2px;
      border-right: 3px solid rgba(64, 158, 255, 0.7);
      border-bottom: 3px solid rgba(64, 158, 255, 0.7);
    }
  }
  .media-container {
    height: 1.1979rem;
    width: 100%;

    #myPlayer {
      height: 1.25rem;
      width: 100%;
    }
    #ui-talk {
      height: 100%;
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index/Home.vue